export default __webpack_public_path__ + "static/media/cashout-icon-home-mobile.b9332ce0.webp";